import { render, staticRenderFns } from "./CommentThread.vue?vue&type=template&id=20ef6335&scoped=true"
import script from "./CommentThread.vue?vue&type=script&lang=ts"
export * from "./CommentThread.vue?vue&type=script&lang=ts"
import style0 from "./CommentThread.vue?vue&type=style&index=0&id=20ef6335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef6335",
  null
  
)

export default component.exports